
import { defineComponent } from "vue";
import { mapActions } from "vuex";
import { ACTIONS } from "../data";
import { DebtAccount } from "../interfaces";
import AccountList from "./AccountList.vue";
import NewAccountForm from "./NewAccountForm.vue";

export default defineComponent({
  name: "AccountSidebar",
  data() {
    return {
      newAccount: false,
      formAccountId: "",
      editAccount: false
    };
  },
  components: {
    AccountList,
    NewAccountForm
  },
  methods: {
    ...mapActions([ACTIONS.addAccount, ACTIONS.updateAccount]),
    handleFormSubmit(account: DebtAccount) {
      // console.log("account", account);
      if (this.editAccount) {
        // console.log("Update account here...", account);
        this[ACTIONS.updateAccount](account);
      } else {
        this[ACTIONS.addAccount](account);
      }
      this.handleFormReset();
    },
    handleFormReset() {
      this.formAccountId = "";
      this.newAccount = false;
      this.editAccount = false;
    },
    handleAccountUpdate(id: string) {
      this.formAccountId = id;
      this.newAccount = true;
      this.editAccount = true;
    }
  }
});
